import { API_ROUTE_ADMIN_LOCATIONS_DETAILS } from '@/resources/api-routes'
import { update } from '@/util/auth'

const IS_NEW_BACKEND_API = true

export const edit = ({
  id,
  payload,
}: {
  id: number
  payload: {
    code: string
    customerId: number
    hidden?: boolean
    name: string
    departmentId: number
    email: string
    customerAddressId: number
    accountingCode?: string | null
    dim1?: string | null
    dim2?: string | null
    dim3?: string | null
    dim4?: string | null
    description: string
  }
}) =>
  update<null>(
    API_ROUTE_ADMIN_LOCATIONS_DETAILS.replace(':costObjectId', String(id)),
    payload,
    IS_NEW_BACKEND_API
  )
